import { DateTime } from "luxon";
import { useCustomSession } from "shared/context/CustomSessionContext";
import { getDisplayNameHelper } from "shared/helpers/profile/getDisplayNameHelper";

const AdminImpersonateInfo: React.FC = () => {
  const session = useCustomSession();
  if (session.societyAdminId || session.environment !== "prod") {
    return (
      <div className="flex flex-col justify-normal items-stretch px-1.5 py-1 border-b border-sidebar-border">
        {session.environment !== "prod" && (
          <>
            <div>
              {session.environment} - {session.iat}
            </div>
            <div>{DateTime.now().toISO()}</div>
          </>
        )}
        {session.societyAdminId || session.environment !== "prod" ? (
          <>
            <div data-testid="impersonate-admin-user">
              Admin : {session.societyAdmin?.name} ({session.societyAdminId})
            </div>
            <div data-testid="impersonate-admin-mode">
              Admin Mode: {session.adminMode ? "ON" : "OFF"}
            </div>
            <div data-testid="impersonate-society-user">
              User: {session.societyUser?.firstName}{" "}
              {session.societyUser?.lastName} (
              {session.societyUser?.societyUserId})
            </div>
            <div data-testid="impersonate-profile">
              Profile: {getDisplayNameHelper(session.profile)} (
              {session.profileId})
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
  return <></>;
};

export default AdminImpersonateInfo;
